import { computed, effect, Injectable, Signal, signal, WritableSignal } from "@angular/core";

const MOBILE_WIDTH_THRESHOLD: number = 768;
const COLLAPSED_DELAYED_TIMEOUT: number = 250;

@Injectable({
  providedIn: "root"
})
export class SidebarService {
  private _timeout: number | undefined;

  private _collapsed: WritableSignal<boolean> = signal(this.isMobile());

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  readonly collapsed: Signal<boolean> = computed(() => this._collapsed());

  private _collapsedDelayed: WritableSignal<boolean> = signal(this._collapsed());

  // eslint-disable-next-line @unicorn/consistent-function-scoping
  readonly collapsedDelayed: Signal<boolean> = computed(() => this._collapsedDelayed());

  constructor () {
    effect(() => {
      const value: boolean = this._collapsed();

      clearTimeout(this._timeout);
      this._timeout = setTimeout(() => {
        this._collapsedDelayed.set(value);
      }, COLLAPSED_DELAYED_TIMEOUT);
    });
  }

  toggleCollapsed (): void {
    this._collapsed.update((v: boolean): boolean => !v);
  }

  // eslint-disable-next-line @tseslint/class-methods-use-this
  private isMobile (): boolean {
    return window.innerWidth <= MOBILE_WIDTH_THRESHOLD;
  }
}
